/* */ 
'use strict';
var $RefParserOptions = require('json-schema-ref-parser/lib/options'),
    util = require('util');
module.exports = ParserOptions;
function ParserOptions(options) {
  $RefParserOptions.call(this, ParserOptions.defaults);
  $RefParserOptions.apply(this, arguments);
}
ParserOptions.defaults = {validate: {
    schema: {order: 1},
    spec: {order: 2}
  }};
util.inherits(ParserOptions, $RefParserOptions);
